import { Tooltip, TooltipProps } from "@fluentui/react-components";
import { HELP_Z } from "./dom";

/**
 * A Fluent tooltip lifted above the guide's own layers. Fluent tooltips stack by DOM order with
 * no z-index, so next to the tour's scrim (a fixed layer with a z-index) they would render
 * underneath it.
 */
export const HelpTooltip = ({
  content,
  children,
  relationship = "label",
  positioning,
}: {
  content: string;
  children: TooltipProps["children"];
  relationship?: TooltipProps["relationship"];
  positioning?: TooltipProps["positioning"];
}) => (
  <Tooltip
    content={{ children: content, style: { zIndex: HELP_Z.tooltip } }}
    relationship={relationship}
    positioning={positioning}
    withArrow
  >
    {children}
  </Tooltip>
);
